module.exports = __webpack_public_path__ + "img/wind-decoration-with-plants.0316af67.webp";